export type LegalDoc = {
  id: 'terminos' | 'privacidad' | 'contacto'
  label: string
  title: string
  sections: { heading: string; body: string[] }[]
}

export const legalDocs: LegalDoc[] = [
  {
    id: 'terminos',
    label: 'Términos y condiciones',
    title: 'Términos y condiciones',
    sections: [
      {
        heading: '1. Sobre el producto',
        body: [
          '«Me Elijo» es un producto 100% digital y descargable, compuesto por un eBook principal y seis recursos complementarios (bonos). No se envía ningún material físico y, por lo tanto, no aplican costos ni tiempos de envío.',
        ],
      },
      {
        heading: '2. Acceso y entrega',
        body: [
          'El acceso se entrega de forma inmediata al confirmarse el pago, a través de un enlace de descarga enviado al correo electrónico registrado en la compra. Es responsabilidad de la compradora ingresar un correo válido y revisar las carpetas de spam o promociones.',
        ],
      },
      {
        heading: '3. Licencia de uso',
        body: [
          'La compra otorga una licencia personal, individual e intransferible. Queda prohibida la reventa, reproducción total o parcial, distribución o publicación de los materiales sin autorización escrita de la autora. Todos los contenidos están protegidos por derechos de autor.',
        ],
      },
      {
        heading: '4. Naturaleza del contenido',
        body: [
          'El contenido tiene fines educativos y de desarrollo personal. No sustituye acompañamiento psicológico, médico ni terapéutico profesional. Si atraviesas una situación de salud mental que requiere atención, te invitamos a buscar apoyo profesional.',
        ],
      },
      {
        heading: '5. Reembolsos',
        body: [
          'Por tratarse de un producto digital de descarga inmediata, una vez entregado el acceso no se realizan reembolsos. Si tienes cualquier inconveniente con la descarga, escríbenos y lo resolvemos contigo.',
        ],
      },
      {
        heading: '6. Precios',
        body: [
          'Los precios están expresados en pesos colombianos (COP) y pueden cambiar sin previo aviso. El precio aplicable es el vigente al momento de completar la compra.',
        ],
      },
    ],
  },
  {
    id: 'privacidad',
    label: 'Política de privacidad',
    title: 'Política de privacidad',
    sections: [
      {
        heading: 'Datos que recopilamos',
        body: [
          'Recopilamos únicamente los datos necesarios para procesar tu compra y entregarte el producto: nombre, correo electrónico y, cuando aplique, país y datos de facturación gestionados por la pasarela de pago.',
        ],
      },
      {
        heading: 'Para qué los usamos',
        body: [
          'Usamos tus datos para entregarte el eBook y los bonos, brindarte soporte, y enviarte contenido y novedades relacionadas con «Me Elijo». Nunca vendemos ni cedemos tu información a terceros con fines comerciales.',
        ],
      },
      {
        heading: 'Pagos seguros',
        body: [
          'No almacenamos datos de tarjetas de crédito o débito. Todos los pagos se procesan mediante pasarelas certificadas que cifran tu información bajo estándares internacionales de seguridad.',
        ],
      },
      {
        heading: 'Tus derechos',
        body: [
          'Puedes solicitar en cualquier momento el acceso, la corrección o la eliminación de tus datos personales, así como darte de baja de nuestros correos con un solo clic al final de cada mensaje.',
        ],
      },
      {
        heading: 'Cookies',
        body: [
          'Este sitio puede utilizar cookies y píxeles de medición para entender cómo se navega la página y mejorar la experiencia de compra. Puedes desactivarlas desde la configuración de tu navegador.',
        ],
      },
    ],
  },
  {
    id: 'contacto',
    label: 'Contacto',
    title: 'Hablemos',
    sections: [
      {
        heading: 'Soporte y ayuda con tu descarga',
        body: [
          'Si tu enlace no llegó, no abre o tienes cualquier duda sobre tu compra, escríbenos a soporte.ingridevolution@outlook.com y te respondemos en un máximo de 24 horas hábiles.',
        ],
      },
      {
        heading: 'Horario de atención',
        body: ['Lunes a viernes, de 9:00 a. m. a 6:00 p. m. (hora Argentina).'],
      },
      
      {
        heading: 'Antes de comprar',
        body: [
          '¿Tienes dudas sobre si «Me Elijo» es para ti? Cuéntanos tu caso por correo. Preferimos una compra consciente antes que una venta apurada.',
        ],
      },
    ],
  },
]
